import {api} from '../../helpers';

export function performSingleDocumentAnalysis(params) {
  return api
    .post('/users/widget/lookup/document-analysis', params)
    .then(res => res.data);
}
